const isLocalHost = typeof window !== 'undefined'
  && ['localhost', '127.0.0.1'].includes(window.location.hostname);

const apiUrl = isLocalHost
  ? 'http://localhost/ghrcemp-angular/api/'
  : 'https://ghrcemp.raisoni.net/api/';

export const environment = {
  production: false,

  siteUrl: 'https://ghrcemp.raisoni.net',

  apiUrl,

  cdnUrl: 'https://rgicdn.s3.ap-south-1.amazonaws.com/ghrcempune/images',

  assetsUrl: 'https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images'
};
